import { chatNewMessagesStr } from '../../../../../chat/modules/common';
import React, { Fragment, PureComponent } from 'react';
import SvgIcon from '../../../../../common/SvgIcon';
import cn from 'classnames';
import PopOver from '../../../../../common/components/PopOver';

const RoomsList = ({ chats, setActiveChat, chatFullsize }) => {
  const chatName = chat => {
    if (chat.name) {
      return chat.name;
    }
    // todo: different mbp/dpp names
    const nameByServiceType = {
      general: 'My Bespoke Room',
      design: 'Designer Chat',
      personal_shopper: 'Shopping Support',
    };
    return nameByServiceType[chat.service_type || 'general'];
  };

  return (
    <div className="chat-popup_rooms-scroll">
      {chats.map(chatRoom => (
        <PopOver
          direction={!chatFullsize ? 'left' : 'right'}
          key={chatRoom.id}
          title={chatName(chatRoom)}
        >
          <div
            className={cn('chat-popup_rooms-list_item', { '-active': chatRoom.active })}
            onClick={() => setActiveChat(chatRoom)}
          >
            <div className="icon">
              <SvgIcon
                width="60px"
                height="60px"
                icon={`icon-chat-${chatRoom.service_type || 'general'}`}
                key={chatRoom.id}
                className="chat-popup_room-type-icon"
              />
              {Boolean(chatRoom.new_messages_count) && (
                <div className="new-messages-count">
                  {chatNewMessagesStr(chatRoom.new_messages_count)}
                </div>
              )}
            </div>
            <div className="chat-popup_rooms-list_item_chat-name">{chatName(chatRoom)}</div>
          </div>
        </PopOver>
      ))}
    </div>
  );
};

export default RoomsList;



// WEBPACK FOOTER //
// ./app/javascript/customer_chat/components/chat/shared/components/RoomsList.js